import styled from '@emotion/styled';
import { IconAndTextButtonLink } from '@blueprint/ui';
import { css } from '@emotion/css';
import { ButtonLinkWithIcon } from '@zoopla/blueprint-button-with-icon';

const LSRP_SIDEBAR_MEDIA_QUERY = `@media only screen and (min-width: 1140px)`;

type MobileAlertPanelWrapperProps = {
    justifyContent?: 'space-evenly' | 'left';
};

export const MobileAlertPanelWrapper = styled(
    'div'
)<MobileAlertPanelWrapperProps>(
    ({ theme, justifyContent = 'space-evenly' }) => css`
        display: flex;
        padding-top: 1.125rem;
        padding-bottom: 0.7rem;
        align-items: center;
        justify-content: ${justifyContent};
        background-color: ${theme.colors['graphic-background']};
        width: 100%;
        margin-top: -1.5rem;

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: none;
        }
    `
);

export const MobileText = styled('p')(
    ({ theme }) => css`
        display: inline;
        margin: 0;
        line-height: ${theme.type.lineHeight};
        font-size: ${theme.type.body};
        color: ${theme.colors['text-body']};

        ${theme.mq.small} {
            display: none;
        }
    `
);
export const TabletText = styled('p')(
    ({ theme }) => css`
        display: none;
        margin: 0;
        line-height: ${theme.type.lineHeight};
        font-size: ${theme.type.body};
        color: ${theme.colors['text-body']};

        ${theme.mq.small} {
            display: inline;
        }
    `
);

export const AlertPanelButtonLinkMobile = styled(IconAndTextButtonLink)(
    () => css`
        border: 0;
        display: flex;
    `
);

export const SaveEditSearchButton = styled(ButtonLinkWithIcon)(
    () => css`
        padding-left: 0;
    `
);

export const Divider = styled('span')(
    ({ theme }) => css`
        width: 0.0625rem;
        height: 2rem;
        background-color: ${theme.colors['graphic-divider']};
        display: inline-block;
    `
);
